<ion-header>
  <app-navheader ></app-navheader>
  <ion-item lines="none">
    <ion-label><h1>{{ 'ARCHIVES.WELCOME.MY_ARCHIVES' | translate }}</h1></ion-label>
  </ion-item>
  <ion-item lines="none" class="separator"></ion-item>
</ion-header>
<ion-content scrollEvents="true" (ionScroll)='onContentScroll($event)'>
	<ion-card>
    <ion-grid>
      <ion-row>
        <ion-col size="6">
          <div id="card-logo" [ngSwitch]="newspaper">
            <img *ngSwitchCase="'mquo'"  src="/../assets/img/monq-logo.png" class="MQ_Logo">
            <img *ngSwitchCase="'lepq'" src="/../assets/img/petitq-logo.png" class="LPQ_Logo">
            <img *ngSwitchCase="'actu'" src="/../assets/img/actulogo.png" class="MQ_Logo">
            <img *ngSwitchCase="'aeco'" src="/../assets/img/eco_logo_article.svg" class="ECHO_Logo">
            <img *ngSwitchCase="'mlwk'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
            <img *ngSwitchCase="'mlne'" src="/../assets/img/my-little-weeklynews_logo_article.svg" class="LPQ_Logo">
            <img *ngSwitchCase="'mljp'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
            <img *ngSwitchCase="'week'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
            <img *ngSwitchCase="'mwne'" src="/../assets/img/my-weeklynews_logo_article.svg" class="MW_Logo">
            <img *ngSwitchCase="'mwjp'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
            <img *ngSwitchCase="'woch'" src="/../assets/img/meine-woche_logo_article.svg" class="WOCH_Logo">
            <img *ngSwitchCase="'sema'" src="/../assets/img/mi-seminal_logo_article.svg" class="WOCH_Logo">
            <img *ngSwitchCase="'clfy'" src="/../assets/logos/clarify_logo_article.svg" class="WOCH_Logo">
          </div>
        </ion-col>
        <ion-col size="6" class="ion-text-end">
          <span class="pb-icon-pb-icon_pdf">
            <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="rule-logo"></div>
		<div class="thematicfiles-wrapper clear">
      <div class="first-archive" *ngFor="let first of firstArchive">
        <div class="first_pdf" (click)= "downloadPdf(first)">
          <img *ngIf="first.newspaper_name === 'A19'" [src]="config.a19PdfHeader" loading="lazy">
          <div [class.text-center]="first.newspaper_name === 'A19'"  [class.acne-container]="first.newspaper_name === 'A19'">
            <img src="{{ first.thumbnail_big }}" />
          </div>
        </div>
        <div class="text">
          <div class="text-number">
            <div *ngIf="first.newspaper_name !== 'A19'" class="pub-number">Nº {{ first.publish_number }}</div>
            <div class="pub-date" *ngIf = "themeClass !== 'woch'">{{ first.publishOn |date:'shortDate':'':locale }}</div>
            <div class="pub-date" *ngIf = "themeClass === 'woch'">{{ first.publishOn |date:'mediumDate':'':locale }}</div>
          </div>
          <div (click)="downloadPdf(first)" class="download-wrapper"><span [class.mt-1]="first.newspaper_name === 'A19'" class="download"></span></div>
        </div>
      </div>
      <div class="thematicfile-content">
        <div class="thematicfile-container" *ngFor="let archive of archives">
          <div class="img-container">
            <img *ngIf="archive.newspaper_name === 'A19'" [src]="config.a19PdfHeader" loading="lazy">
            <div [class.text-center]="archive.newspaper_name === 'A19'"  [class.acne-container]="archive.newspaper_name === 'A19'">
              <img [class.acne]="archive.newspaper_name === 'A19'" [src]="archive.thumbnail_big" (click)= "downloadPdf(archive)"/>
            </div>
          </div>
          <div class="text">
            <div class="text-number">
                <div *ngIf="archive.newspaper_name !== 'A19'" class="pub-number">Nº {{archive.publish_number}}</div>
                <div class="pub-date" *ngIf = "themeClass !== 'woch'">{{archive.publishOn |date:'shortDate':'':locale}}</div>
                <div class="pub-date" *ngIf = "themeClass === 'woch'">{{archive.publishOn |date:'mediumDate':'':locale}}</div>
            </div>
            <div (click)="downloadPdf(archive)" class="download-wrapper"><span [class.mt-1]="archive.newspaper_name === 'A19'" class="download"></span></div>
          </div>
        </div>
      </div>
		</div>
    <ion-infinite-scroll (ionInfinite)="doInfinite($event)">
      <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
	</ion-card>
	<app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer><app-bottom-menu [isActive] = "isActivePage"></app-bottom-menu></ion-footer>
<ion-modal [isOpen]="isCalameoModalOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title><div class="close" (click)="setCalameoOpen(false)"><span>FERMER</span><img src="../../../../assets/img/icon-close.png" /></div></ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <iframe width="100%" height="100%" frameborder="0" scrolling="no" style="margin:0 auto;" allowtransparency allowfullscreen [src]="iFrameCalameoSrc"></iframe>
    </ion-content>
  </ng-template>
</ion-modal>
<app-pop-up [show]="tempPopUp" [data]="popup" #temppopup></app-pop-up>
<ion-spinner *ngIf="showSpinner" name="lines" color="primary"></ion-spinner>
